import React from 'react'

import { Modal } from '../../common/components/modal'
import { ReportBlock } from './report-block'

export const ChildBlockModal = function ({ isOpen, report, title, childBlocks, selectionsForChildBlocks, onClose = function () {} }) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title} width={1100}>
      {selectionsForChildBlocks && childBlocks.map((childBlock) => {
        let { props, ...block } = childBlock

        if (selectionsForChildBlocks[block.key]) {
          props = { ...props, parentBlockSelections: selectionsForChildBlocks[block.key] }
        }

        return (
          <ReportBlock key={block.key} blockKey={block.key} report={report} props={props} {...block} />
        )
      })}
    </Modal>
  )
}
